module.exports = __webpack_public_path__ + "img/bg-yoda2.a299eed8.png";